import { ReachAPI } from './ReachAPI';
import { Log } from '../AuxillaryService/Log';

/**
 * @class signage
 * @hideconstructor
 * @memberof ReachAPI
 */
ReachAPI.signage = {};

/**
 * GET Endpoint `/signage/notice/codes`
 * @throws {jqpFailure}
 * @returns {jqpSuccess}
 * @memberof ReachAPI.signage
 */
ReachAPI.signage.getNoticeCodes = function () {
    var url = ReachAPI.server + '/signage/notice/codes';
    var jqPromise = ReachAPI.getWithFallback(url, 'json');

    jqPromise.done(function (data, textStatus) {
        if (textStatus === 'cache') {
            Log.Debug('Retrieved Notice Codes from the CACHE (API call failed)', null, __fileline);
        } else {
            Log.Debug('Retrieved Notice Codes from the API', null, __fileline);
        }
    });

    jqPromise.fail(function (jqXHR, textStatus, errorThrown, msg, event) {
        Log.Warning(
            'Failed to retrieve Notice Codes',
            null,
            __fileline,
            ReachAPI.createPromiseFailObject(jqXHR, textStatus, errorThrown, msg, event)
        );
    });

    return jqPromise;
};

/**
 * Get Schedule Data
 * @param {string|number} facility_id
 * @param {string|number} screen_id
 * @param [format]
 * @param [additional_days]
 * @param [now]
 * @param [use_local_time]
 * @param [show_expired_data]
 * @param [optional_date]
 * @throws {jqpFailure}
 * @returns {GetScheduleResponse}
 * @memberof ReachAPI.signage
 */
ReachAPI.signage.getSchedule = function (
    facility_id,
    screen_id,
    format,
    additional_days,
    now,
    use_local_time,
    show_expired_data,
    optional_date
) {
    var cache_id =
        '/schedule/facility=' +
        facility_id +
        '/screen=' +
        screen_id +
        '/format=' +
        format +
        '/additional_days=' +
        additional_days;
    ///signage/schedule/
    var url = ReachAPI.server + '/signage/schedule/' + facility_id + '/' + screen_id;
    var data = {
        format: format,
        additional_days: additional_days,
        now: now,
        use_local_time: use_local_time,
        show_expired_data: show_expired_data,
        date: optional_date,
    };
    var jqPromise = ReachAPI.getWithFallback(url, 'json', data, cache_id);

    jqPromise.done(function (data, textStatus) {
        if (textStatus === 'cache') {
            Log.Debug('Retrieved Schedule from the CACHE (API call failed)', null, __fileline);
        } else {
            Log.Debug('Retrieved Schedule from the API', null, __fileline);
        }
    });

    jqPromise.fail(function (jqXHR, textStatus, errorThrown, msg, event) {
        Log.Warning(
            'Failed to retrieve Schedule',
            null,
            __fileline,
            ReachAPI.createPromiseFailObject(jqXHR, textStatus, errorThrown, msg, event)
        );
    });

    return jqPromise;
};

/**
 * Get Calendar Data
 * @param {string|number} facility_id
 * @param {string|number} group_id
 * @param {Array.<String>} calendar_list
 * @param {string} start_date (format: YYYY-MM-DD HH:mm:ss)
 * @param {string} end_date (format: YYYY-MM-DD HH:mm:ss)
 * @throws {jqpFailure}
 * @returns {jqpSuccess}
 * @memberof ReachAPI.signage
 */
ReachAPI.signage.getCalendars = function (
    facility_id,
    group_id,
    calendar_list,
    start_date,
    end_date
) {
    var cache_id = null;
    var url = ReachAPI.server + '/signage/calendar/' + facility_id;
    var data = {
        start_date: start_date,
        end_date: end_date,
        calendar_list: calendar_list,
        group_id: group_id,
    };

    var jqPromise = ReachAPI.getWithFallback(url, 'json', data, cache_id);

    jqPromise.done(function (data, textStatus) {
        if (textStatus === 'cache') {
            Log.Debug('Retrieved calendar data from the CACHE (API call failed)', null, __fileline);
        } else {
            Log.Debug('Retrieved calendar data from the API', null, __fileline);
        }
    });

    jqPromise.fail(function (jqXHR, textStatus, errorThrown, msg, event) {
        Log.Warning(
            'Failed to retrieve calendar data',
            null,
            __fileline,
            ReachAPI.createPromiseFailObject(jqXHR, textStatus, errorThrown, msg, event)
        );
    });

    return jqPromise;
};

/**
 * Get Schedule Data
 * @param {string|number} facility_id
 * @param {string|number} group_id
 * @throws {jqpFailure}
 * @returns {jqpSuccess}
 * @memberof ReachAPI.signage
 * @todo move to ReachAPI.calendar
 */
ReachAPI.signage.getCalendarGroups = function (facility_id, group_id) {
    var cache_id = '/calendar/groups/facility=' + facility_id + '/group_id=' + group_id;
    var url = ReachAPI.server + '/signage/calendar/groups/' + group_id;
    var data = {
        facility_id: facility_id,
    };

    var jqPromise = ReachAPI.getWithFallback(url, 'json', data, cache_id);

    jqPromise.done(function (data, textStatus) {
        if (textStatus === 'cache') {
            Log.Debug(
                'Retrieved calendar group data from the CACHE (API call failed)',
                null,
                __fileline
            );
        } else {
            Log.Debug('Retrieved calendar group data from the API', null, __fileline);
        }
    });

    jqPromise.fail(function (jqXHR, textStatus, errorThrown, msg, event) {
        Log.Warning(
            'Failed to retrieve calendar group data',
            null,
            __fileline,
            ReachAPI.createPromiseFailObject(jqXHR, textStatus, errorThrown, msg, event)
        );
    });

    return jqPromise;
};

/**
 * Get Calendar Info
 * @param {string|number} facility_id
 * @param {string} calendar_id
 * @throws {jqpFailure}
 * @returns {jqpSuccess}
 * @memberof ReachAPI.signage
 * @todo move to ReachAPI.calendar
 */
ReachAPI.signage.getCalendar = function (facility_id, calendar_id) {
    var cache_id = '/calendar/facility=' + facility_id + '/calendar_id=' + calendar_id;
    var url = ReachAPI.server + '/signage/calendar/' + facility_id + '/' + calendar_id;
    var data = {};
    var jqPromise = ReachAPI.getWithFallback(url, 'json', data, cache_id);

    jqPromise.done(function (data, textStatus) {
        if (textStatus === 'cache') {
            Log.Debug(
                'Retrieved calendar group data from the CACHE (API call failed)',
                null,
                __fileline
            );
        } else {
            Log.Debug('Retrieved calendar group data from the API', null, __fileline);
        }
    });

    jqPromise.fail(function (jqXHR, textStatus, errorThrown, msg, event) {
        Log.Warning(
            'Failed to retrieve calendar group data',
            null,
            __fileline,
            ReachAPI.createPromiseFailObject(jqXHR, textStatus, errorThrown, msg, event)
        );
    });

    return jqPromise;
};

/**
 * Get Calendar Info and all Events
 * @param {string} calendar_id
 * @throws {jqpFailure}
 * @returns {jqpSuccess}
 * @memberof ReachAPI.signage
 * @todo move to ReachAPI.calendar
 */
ReachAPI.signage.getAllCalendarEvents = function (calendar_id) {
    var cache_id = '/calendar/all/events/calendar_id=' + calendar_id;
    var url = ReachAPI.server + '/signage/calendar/all/events/' + calendar_id;
    var data = {};
    var jqPromise = ReachAPI.getWithFallback(url, 'json', data, cache_id);

    jqPromise.done(function (data, textStatus) {
        if (textStatus === 'cache') {
            Log.Debug(
                'Retrieved calendar group data from the CACHE (API call failed)',
                null,
                __fileline
            );
        } else {
            Log.Debug('Retrieved calendar group data from the API', null, __fileline);
        }
    });

    jqPromise.fail(function (jqXHR, textStatus, errorThrown, msg, event) {
        Log.Warning(
            'Failed to retrieve calendar group data',
            null,
            __fileline,
            ReachAPI.createPromiseFailObject(jqXHR, textStatus, errorThrown, msg, event)
        );
    });

    return jqPromise;
};

/**
 * Get Signage Configuration
 * @param {ReachAPI.Security} security
 * @param {number} [display_id]
 * @param {string | null} v2Permissions
 * @throws {jqpFailure}
 * @returns {jqpSuccess}
 * @memberof ReachAPI.signage
 */
ReachAPI.signage.getSignageConfiguration = function (security, display_id, v2Permissions) {
    var cache_id = '/signage/configuration';
    var url = ReachAPI.server + '/signage/configuration';
    var params = {};
    var headers = undefined;
    var jqPromise;

    if (display_id && security.token) {
        cache_id += '/display=' + display_id + '/token=' + security.token;
        url += '/preview/' + display_id;
        params.token = security.token;
        if (v2Permissions !== null) {
            headers = { 'x-new-permissions': 'true' };
        }
    } else {
        cache_id += '/player=' + security.player_uuid;
        url += '/' + security.player_uuid;
    }

    jqPromise = ReachAPI.getWithFallback(url, 'json', params, cache_id, headers);

    jqPromise.done(function (data, textStatus) {
        if (textStatus === 'cache') {
            Log.Debug(
                'Retrieved Signage Configuration from the CACHE (API call failed)',
                null,
                __fileline
            );
        } else {
            Log.Debug('Retrieved Signage Configuration from the API', null, __fileline);
        }
    });

    jqPromise.fail(function (jqXHR, textStatus, errorThrown, msg, event) {
        Log.Warning(
            'Failed to retrieve Signage Configuration',
            null,
            __fileline,
            ReachAPI.createPromiseFailObject(jqXHR, textStatus, errorThrown, msg, event)
        );
    });

    return jqPromise;
};

/**
 * Get Widget Configuration
 * @param {number} widget_id
 * @throws {jqpFailure}
 * @returns {jqpSuccess}
 */
ReachAPI.signage.getWidgetConfig = function (widget_id) {
    var cache_id = '/widget/configuration/widget=' + widget_id;
    var url = ReachAPI.server + '/signage/widgetconfiguration/' + widget_id;
    var params = {};
    var jqPromise = ReachAPI.getWithFallback(url, 'json', params, cache_id);

    jqPromise.done(function (data, textStatus) {
        if (textStatus === 'cache') {
            Log.Debug(
                'Retrieved Widget Config (for Widget:' +
                    widget_id +
                    ') from the CACHE (API call failed)',
                null,
                __fileline
            );
        } else {
            Log.Debug(
                'Retrieved Widget Config (for Widget:' + widget_id + ') from the API',
                null,
                __fileline
            );
        }
    });

    jqPromise.fail(function (jqXHR, textStatus, errorThrown, msg, event) {
        Log.Warning(
            'Failed to retrieve Widget Config for Widget:' + widget_id,
            null,
            __fileline,
            ReachAPI.createPromiseFailObject(jqXHR, textStatus, errorThrown, msg, event)
        );
    });

    return jqPromise;
};

/**
 * PUT Endpoint `/signage/notice`
 * @param {string} uuid
 * @param {number} code
 * @param {string} [message]
 * @param {Object} [data]
 * @returns {jQuery.jqXHR}
 * @memberof ReachAPI.signage
 */
ReachAPI.signage.putNotice = function (uuid, code, message, data) {
    var url = ReachAPI.server + '/signage/notice/' + uuid;
    var params = {
        code: code,
    };

    if (message) {
        params.message = message;
    }
    if (data) {
        params.data = JSON.stringify(data);
    }

    return ReachAPI.put(url, params);
};

/**
 * @typedef {object} DataList.listData
 * @property {DataList.listConfig} list
 * @property {Array.<DataList.columnConfig>} columns
 * @property {Array.<DataList.rowData>} rows
 */

/**
 * @typedef {object} DataList.listConfig
 * @property {string} data_list_name
 * @property {string} data_list_type
 * @property {string} id
 */

/**
 * @typedef {object} DataList.columnConfig
 * @property {string} data_list_id
 * @property {string} id
 * @property {boolean} is_identity
 * @property {string} name
 * @property {string} ordinal
 * @property {string} ordinal_as_alpha
 * @property {string} type
 * @property {string} width
 */

/**
 * @typedef {Array.<DataList.cellData>} DataList.rowData
 */

/**
 * @typedef {object} DataList.cellData
 * @property {string} column_ordinal
 * @property {string} id
 * @property {string} is_raw_json
 * @property {string} row_id
 * @property {string} row_ordinal
 * @property {string} value
 */

/**
 * Retrieve data list
 * @param {string} listId - Base 36 number
 * @param {string} [cellRange] - e.g., `1:`, `A2:D10`
 * @param {boolean} [showMissingRows] - `true` by default. Fill in sparse data
 * with missing rows
 * @param {ReachAPI.Security} security
 * @throws {jqpFailure}
 * @returns {jqpSuccess}
 */
ReachAPI.signage.getList = function (listId, cellRange, showMissingRows, security) {
    var url = ReachAPI.server + '/signage/datalist/' + listId;
    var params = {
        cell_range: cellRange,
        show_missing_rows: showMissingRows ? 'true' : 'false',
        return: 'json',
    };
    var jqPromise;

    // add security data
    params = security.merge(params);

    jqPromise = ReachAPI.getWithFallback(url, 'json', params);

    jqPromise.done(function (data, textStatus) {
        if (textStatus === 'cache') {
            Log.Debug('Retrieved Data Lists from the CACHE (API call failed)', null, __fileline);
        } else {
            Log.Debug('Retrieved Data Lists from the API', null, __fileline);
        }
    });

    jqPromise.fail(function (jqXHR, textStatus, errorThrown, msg, event) {
        Log.Warning(
            'Failed to retrieve Data Lists',
            null,
            __fileline,
            ReachAPI.createPromiseFailObject(jqXHR, textStatus, errorThrown, msg, event)
        );
    });

    return jqPromise;
};
